import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationCheckpoint.ts
function useLocationCheckpoint(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationCheckpointDetail.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationCheckpoint };

//# sourceMappingURL=useLocationCheckpoint.js.map